import { motion } from "framer-motion";
import { imgSrc, catName } from "../lib/api";
import { LikeButton } from "./LikeButton";

export const PhotoCard = ({ photo, rank, onOpen, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.45, delay: (index % 8) * 0.05 }}
    data-testid={`photo-card-${photo.id}`}
    onClick={() => onOpen?.(photo)}
    className="group relative mb-5 cursor-zoom-in break-inside-avoid overflow-hidden rounded-xl border border-white/10 bg-[#12121A] transition-[border-color,box-shadow] duration-300 neon-border"
  >
    <img src={imgSrc(photo.src)} alt={photo.title} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
    {rank && (
      <span data-testid={`photo-rank-${photo.id}`} className={`absolute left-3 top-3 rounded-md px-2.5 py-1 font-display text-lg font-black ${rank === 1 ? "bg-lime-400 text-black" : rank <= 3 ? "bg-cyan-400 text-black" : "bg-black/70 text-white"}`}>
        #{rank}
      </span>
    )}
    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent p-4 pt-12">
      <div className="flex items-end justify-between gap-3">
        <div className="min-w-0">
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-cyan-300">{catName(photo.category)}</p>
          <h4 className="truncate font-display text-xl font-bold uppercase leading-tight">{photo.title}</h4>
          <p className="truncate text-xs text-slate-400">por {photo.user_name}</p>
        </div>
        <LikeButton photo={photo} />
      </div>
    </div>
  </motion.div>
);
